import React, { useEffect } from 'react';
import ServicesBreadcrumbs from '../components/ServicesBreadcrumbs';
import ServicesMain from '../components/ServicesMain';
import ContactCTA from '../components/ContactCTA';
import WOW from 'wowjs';

const Services = () => {
  useEffect(() => {
    // Initialize WOW.js for animations
    new WOW.WOW({ live: false }).init();
  }, []);

  return (
    <>
      <ServicesBreadcrumbs />
      <ServicesMain />
      <ContactCTA />
    </>
  );
};

export default Services;